import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core';
import { DashboardModule } from './home/dashboard';
import { ShellModule } from './shell/shell.module';
import { LoginModule } from './login';

import { AppComponent } from './app.component';
import { DomainsModule } from './domains/domains.module';
import { ToastContainerComponent } from './domains/shared/components/toast/toast-container.component';
import { ToastComponent } from './domains/shared/components/toast/toast.component';
import { ForbiddenModule } from './forbidden/forbidden.module';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localePt);

(window as any).global = window;

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    CoreModule,
    SharedModule,

    AppRoutingModule,
    LoginModule,
    ShellModule,
    DomainsModule,
    DashboardModule,
    ForbiddenModule,
  ],
  declarations: [
    AppComponent,
    ToastComponent,
    ToastContainerComponent,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
